import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import { Scissors, ShieldCheck, Gem, Sparkles } from 'lucide-react';

const ServicesSection = ({ settings }) => {
    const [services, setServices] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const content = {
        servicesTitle: settings?.servicesTitle || 'OS NOSSOS SERVIÇOS',
        servicesSubtitle: settings?.servicesSubtitle || 'Excelência e cuidado em cada procedimento que oferecemos.',
        servicesImageUrl: settings?.servicesImageUrl || '',
        servicesImageAlt: settings?.servicesImageAlt || '' // Descrição da imagem para SEO
    };

    const icons = {
        Corte: <Scissors size={24} />,
        Barba: <ShieldCheck size={24} />,
        Pacote: <Sparkles size={24} />,
        Tratamento: <Gem size={24} />,
    };

    const getIcon = (name = '') => {
        if (name.includes('Corte')) return icons.Corte;
        if (name.includes('Barba')) return icons.Barba;
        if (name.includes('Pacote')) return icons.Pacote;
        if (name.includes('Tratamento')) return icons.Tratamento;
        return icons.Corte;
    };

    useEffect(() => {
        const fetchServices = async () => {
            const servicesSnapshot = await getDocs(collection(db, 'services'));
            const servicesList = servicesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setServices(servicesList);
            setIsLoading(false);
        };
        fetchServices();
    }, []);

    if (!settings) {
        return <section id="servicos" className="py-20 md:py-32 bg-background/50"></section>;
    }

    const containerClasses = services.length === 1
        ? 'flex justify-center'
        : 'grid sm:grid-cols-2 lg:grid-cols-4 gap-8';

    const sectionStyle = content.servicesImageUrl ? {
        backgroundImage: `url(${content.servicesImageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
    } : {};

    return (
        <section 
            id="servicos" 
            className="py-20 md:py-32 relative bg-background/50"
            style={sectionStyle}
            role="img"
            aria-label={content.servicesImageAlt || content.servicesTitle}
        >
            {content.servicesImageUrl && <div className="absolute inset-0 bg-black/70"></div>}

            <div className="container mx-auto px-6 text-center relative z-10">
                <h2 className="text-3xl md:text-4xl font-bold mb-2 text-primary">{content.servicesTitle}</h2>
                <p className="text-white mb-12 max-w-xl mx-auto">{content.servicesSubtitle}</p>
                {isLoading ? (
                    <p>A carregar serviços...</p>
                ) : (
                    <div className={containerClasses}>
                        {services.map((service) => {
                            const priceValue = service.price ? parseFloat(service.price.replace(/[^0-9,]+/g, "").replace(",", ".")) : 0;

                            return (
                                <div key={service.id} className="w-full max-w-sm bg-neutral-900/80 backdrop-blur-sm p-8 rounded-lg border border-neutral-700/50 text-left transition-all duration-300 hover:border-primary/50 hover:shadow-xl hover:shadow-black/30 hover:-translate-y-2">
                                    <div className="text-primary mb-4">{getIcon(service.name)}</div>
                                    <h3 className="text-xl font-bold text-white mb-2">{service.name}</h3>
                                    
                                    {priceValue > 0 && (
                                        <p className="text-2xl font-bold mb-4 text-primary">{service.price}</p>
                                    )}
                                    
                                    <p className="text-text/80 text-sm">{service.description}</p>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

export default ServicesSection;
